<script>
import VETimg from '@/assets/icon_bars/Picture1.jpg';


export default {
    name: 'PrivacyTicketPage',
    data() {
        return {
            ListPolicyCn,
            VETimg,
        };
    },
}

const ListPolicyCn = [

    {
        id: 1,
        p1: 'Vireak Buntham 完全尊重您的隐私，并认识到需要保护您与我们分享的个人身份信息（任何可以识别您身份的信息，例如姓名、地址和电话号码）。我们向您保证在保护您在我们网站上的隐私时，我们遵循适当的标准。',


    },
    {
        id: 2,
        p2: '我们的隐私政策可能随时更改，恕不另行通知。为确保您了解任何更改，请定期查看本政策。访问本网站即表示您同意受本隐私政策的条款和条件的约束。 如果您不同意，请不要使用或访问我们的网站。仅使用本网站，即表示您明确同意我们根据本隐私政策使用和披露您的个人信息。本隐私政策已纳入使用条款并受其约束。',


    },
    {

        id: 3,
        p3: '未经用户或客户同意（除非传票、 搜查令或其他法律程序或在用户或其他人即将遭受人身伤害的情况下）',

    },

]
</script>


<template>
    <div class="container">
        <div>
            <div>
                <img style="height: 48px;" :src="VETimg" alt="VET Image" />
            </div>
            <div>
                <h2 class="content-title">Privacy Policy for Tickets</h2>
                <ul style="padding-left: 0%;">
                    <li style="list-style: none;">
                        <p class="text_p">{{ $t('message.p1') }}</p>
                    </li>
                    <li style="list-style: none;">
                        <p class="text_p">{{ $t('message.p2') }}</p>
                    </li>
                    <li style="list-style: none;">
                        <p class="text_p">{{ $t('message.p3') }}</p>
                    </li>
                </ul>
            </div>
        </div>
        <div>
            <div>
                <div>
                    <img style="height: 48px;" :src="VETimg" alt="VET Image" />
                </div>
                <div>
                    <h2 class="content-title">车票隐私政策</h2>
                    <ul class="ListLink" style="padding-left: 0%;">
                        <li v-for="item in ListPolicyCn" :key="item.id" style="padding-bottom: 12px; list-style: none;">
                            {{ item.p1 }}
                            {{ item.p2 }}
                            {{ item.p3 }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>